"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function Promotions(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingTop: "5%"
    }
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("b", {
    style: {
      fontFamily: "Roboto",
      color: "#000000"
    }
  }, props.promotionalContent.promotionTitle))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: props.promotionalContent.webLink,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: props.promotionalContent.imageLink,
    style: {
      height: '150%',
      width: '100%'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    "data-e2e": "promotionData",
    style: {
      fontFamily: "Roboto",
      paddingTop: "5%",
      paddingBottom: "4%"
    }
  }, props.promotionalContent.content));
}
var _default = Promotions;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/Promotions.js
 ** module id = 2395
 ** module chunks = 0
 **/